import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from '../BookingInfoConstructor.css';

export function Paragraphs({ children: paragraphs }: { children: string[] | undefined }) {
  if (!paragraphs || !paragraphs.length) {
    return null;
  }

  return (
    <>
      {paragraphs.map((paragraph, index) => (
        <div className={styles['paragraph']} key={index}>
          <UIText1 key={index}>{paragraph}</UIText1>
        </div>
      ))}
    </>
  );
}
